import { useState } from "react";
import { changePassSchema } from "../../schemas/Login/changePassSchema";
import { useFormik } from "formik";
import { changePass } from "../../api/userAPI";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Alert from "react-bootstrap/Alert";

export default function CambiarPass() {
  const [esperando, setEsperando] = useState(true);
  const [respuesta, setRespuesta] = useState("");
  const [alertType, setAlertType] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeat, setShowRepeat] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const onSubmit = async (values, actions) => {
    setEsperando(true);
    try {
      const response = await changePass(token, values.userPassword);
      if (response.data) {
        setAlertType("success");
        setRespuesta(response.data.msj);
        setEsperando(false);
        setTimeout(() => {
          navigate("/login");
        }, 1500);
      }
    } catch (error) {
      setAlertType("danger");
      const msg =
        error.response?.data?.msj ||
        error.response?.data?.msg ||
        "Error desconocido";
      setRespuesta(msg);
      setEsperando(false);
    }
    actions.resetForm();
  };
  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      userPassword: "",
      repeatPassword: "",
    },
    validationSchema: changePassSchema,
    onSubmit,
  });
  if (token === null || token === undefined || token === "") {
    return (
      <Alert variant="danger" style={{ textAlign: "center" }}>
        <b>Error: Token no proporcionado.</b>
      </Alert>
    );
  }
  return (
    <div className="custom-container pt-4">
      {esperando ? null : (
        <Alert variant={alertType} style={{ textAlign: "center" }}>
          <b>{respuesta}</b>
        </Alert>
      )}
      <form onSubmit={handleSubmit} className="login-container m-auto">
        <label>Contraseña</label>
        <div style={{ position: "relative" }}>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Contraseña"
            name="userPassword"
            value={values.userPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            className={
              errors.userPassword && touched.userPassword ? "input-error" : ""
            }
          />
          <span
            onClick={() => setShowPassword((v) => !v)}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#888",
            }}
          >
            {showPassword ? (
              <i className="bi bi-eye-slash"></i>
            ) : (
              <i className="bi bi-eye"></i>
            )}
          </span>
        </div>
        {errors.userPassword && touched.userPassword && (
          <p className="error">{errors.userPassword}</p>
        )}
        <label>Repetir Contraseña</label>
        <div style={{ position: "relative" }}>
          <input
            type={showRepeat ? "text" : "password"}
            placeholder="Repetir contraseña"
            name="repeatPassword"
            value={values.repeatPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            className={
              errors.repeatPassword && touched.repeatPassword
                ? "input-error"
                : ""
            }
          />
          <span
            onClick={() => setShowRepeat((v) => !v)}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#888",
            }}
          >
            {showRepeat ? (
              <i className="bi bi-eye-slash"></i>
            ) : (
              <i className="bi bi-eye"></i>
            )}
          </span>
        </div>
        {errors.repeatPassword && touched.repeatPassword && (
          <p className="error">{errors.repeatPassword}</p>
        )}
        <button className="customBtn" disabled={isSubmitting} type="submit">
          Cambiar contraseña
        </button>
      </form>
    </div>
  );
}
